import { FC } from "react";
import { Typography } from "@mui/material";
import { NotificationDto } from "@/modules/notification-center/dtos";
import { useMarkSingleNotification } from "@/modules/notification-center/hooks/mark-single-notification.hook.ts";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface Props {
  notification: NotificationDto;
  label?: string;
}

export const NotificationLinkAction: FC<Props> = ({
  notification,
  label = "View lead",
}) => {
  const { markSingleReadOrUnread } = useMarkSingleNotification();

  const handleClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();

    const newTab = window.open(notification.link || "#", "_blank");
    if (!notification.read) {
      markSingleReadOrUnread({ id: notification.id, read: true });
    }
    newTab?.focus();
  };

  return (
    <Typography
      onClick={handleClick}
      sx={{
        ...nawyTheme.nawy.typography.english.variants.body.sm.semibold,
        color: nawyTheme.nawy.colors.semantic.text.accent,
        cursor: "pointer",
        width: "fit-content",
      }}
    >
      {label}
    </Typography>
  );
};
